export enum AddBlockMode {
  ADD_TRANSFORM_BLOCK = "ADD_TRANSFORM_BLOCK",
  ADD_FINGERPRINT_BLOCK = "ADD_FINGERPRINT_BLOCK",
  DRAW_FIELD_BOXES = "DRAW_FIELD_BOXES",
  ADD_PACKAGE_TABLE = "ADD_PACKAGE_TABLE",
}
